export class RestoreEksNamespaceInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "filesTarget",
            "baseName": "filesTarget",
            "type": "S3RestoreTarget",
            "format": ""
        },
        {
            "name": "volumeSettings",
            "baseName": "volumeSettings",
            "type": "Array<RestoreEksNamespaceVolumeInput>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreEksNamespaceInput.attributeTypeMap;
    }
    constructor() {
    }
}
